import React, { useState, useEffect, Suspense, useContext } from 'react';
import { addSettings } from './SettingService';
import { TostMsg } from '../../../App';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { orgSettings } from '../../../Services/Global-Services/GlobalServices';
import moment from 'moment';
import { GetMasterSystemAlert } from "../../../Services/Global-Services/GlobalServices";
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
const ComponentLoader = React.lazy(() => import("../../../Shared/Sidebar/ComponentLoader"));

function Setting() {
    let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
    const [isLoading, setIsLoading] = useState(false);
    const toster = useContext(TostMsg);
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const [settingList, setSettingList] = useState([]);
    const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
    const [loader, setLoading] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);
    const formatDate = (date) => moment(date).format('MMM DD YYYY');
    const dropdownOptions = [
        { id: 201, value: 'HR' },
        { id: 202, value: 'IT' },
        { id: 303, value: 'Manager' },
    ];
    useEffect(() => { OrgSettings() }, []);

    const OrgSettings = async () => {
        setIsLoading(true);
        let param = {
            OrgId: userDetails?.OrgId
        }
        try {
            let responce = await orgSettings(param);
            setSettingList(responce?.Data);
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    const onRowEditComplete = async (e) => {
        setIsLoading(true);
        let valueOfField;
        if (isDate(e.newData.Value)) {
            valueOfField = new Date(e.newData.Value);
        } else {
            valueOfField = e.newData.Value.toString();
        }
        let param = {
            Id: e?.newData?.Id,
            CreatedDate: formatDate(new Date()),
            ModifiedDate: formatDate(new Date()),
            CreatedBy: userDetails?.EmpId,
            ModifiedBy: userDetails?.EmpId,
            OrgId: userDetails?.OrgId,
            Value: valueOfField, // id for dropdown
            KeyId: 101,//e?.data?.KeyId,
            Text: e?.newData?.Text,
            "GUID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            "IsActive": true, 
        }
        try {
            await addSettings(param);
            OrgSettings();
            setIsLoading(false);
            GetMasterSystemAlertList('Setting_Update')
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
            toster.current.errpr('Something went wrong.')
        }
    };

    const DATE_FORMAT = "DD-MM-YYYY";

    const textEditor = (options) => {
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    };

    const valueField = (options, index) => {
        let newDate = new Date(options?.value)//new Date(options?.value)?.toISOString()?.split('T')[0]; //value={moment(newDate)?.format('dd-mm-YYYY')}//new Date('2024-11-13T06:13:47.738Z')//
        isDate(newDate);
        if (isDate(newDate)) {
            return <Calendar type='date' placeholder="dd-mm-yyyy" dateFormat="dd/mm/yy" min="2008-01-01" value={newDate} onChange={(e) => {options.editorCallback(e.value) }} />;
        }
        else if (options.rowData?.Text == 'setting 4') {
            return <div key={index}><Dropdown value={newDate} onChange={(e) => options.editorCallback(e.value)} options={dropdownOptions} optionLabel="value" optionValue='id'
                placeholder="Please Select a Role" className="w-full md:w-14rem" /></div>
        }
        else {
            return <Calendar type='number' value={newDate} onChange={(e) => options.editorCallback(e.target.value)} />
        }

    };

    const valueFieldType = (rowData) => {
        const dropdownOptionValue = dropdownOptions.find(value => value.id === rowData.Value);
        return (
            <div>
                {isDate(rowData?.Value) && <span>{moment(rowData?.Value).format(DATE_FORMAT)}</span>}
                {!isDate(rowData?.Value) && rowData?.Text !== 'setting 4' && <span>{rowData?.Value}</span>}
                {rowData?.Text === 'setting 4' && <span>{dropdownOptionValue?.value}</span>}
            </div>
        );
    };




    function isDate(value) {
        // const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
        // return dateRegex.test(value);
        const date = new Date(value);
        return !isNaN(date.getTime());
    }

    async function GetMasterSystemAlertList(message) {
        SystemAlerts?.filter((msg) => {
            if (msg?.Name == message) {
                setMasterSystemAlertData(msg?.Data);
            }
        });
    }

    useEffect(() => {
        if (masterSystemAlertData.length > 0) {
            toster.current.success(masterSystemAlertData[0]?.Desc);
        }
    }, [masterSystemAlertData, selectedRole]);




    return (
        <div>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-md-10 onboarding-screen">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="remain-option mt-0">
                                            <h2>Manage Setting</h2>
                                            <div className="row justify-content-center">
                                                <div className="col-xl-12">
                                                    <div className="addcourseform mt-4">
                                                        <div className="card">
                                                            <DataTable value={settingList} removableSort editMode='row' dataKey='Id' onRowEditComplete={onRowEditComplete} tableStyle={{ minWidth: '50rem' }} onChange={textEditor}  >
                                                                <Column field="Text" header="Text" editor={(options) => textEditor(options)} style={{ width: '25%' }}></Column>
                                                                <Column field='Value' body={valueFieldType} header="Value" editor={(options) => valueField(options)} style={{ width: '25%' }}></Column>
                                                                <Column rowEditor={true} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {isLoading ? <Suspense><ComponentLoader /></Suspense> : ''}
            </div>
        </div>
    )
}

export default Setting